// extracted by mini-css-extract-plugin
export default {"home":"home_home__sDTo1","home__welcome":"home_home__welcome__X7zyB","logo":"home_logo__MYy2v"};